<template>
  <div style="display: contents">
    <slot
      :ready="isMetaReady"
      :global="global"
      :view="view"
      :model="model"
      :meta="meta"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    appName: { type: String, default: '' },
    modelName: { type: String, default: '' },
    modelType: { type: String, default: '' },
  },
  computed: {
    ...mapState('meta', ['global', 'view', 'model']),
    ...mapGetters('meta', ['isMetaReady', 'getMeta']),
    meta() {
      return (
        (this.isMetaReady &&
          this.appName &&
          this.modelName &&
          this.modelType &&
          this.getMeta(this.appName, this.modelName, this.modelType)) ||
        {}
      )
    },
  },
  watch: {
    isMetaReady: {
      handler: function (ready) {
        if (ready) {
          this.$emit('ready', {
            global: this.global,
            view: this.view,
            model: this.model,
          })
        }
      },
      immediate: true,
    },
  },
}
</script>
